// Pending-activation gate page. Ported pixel-for-pixel from
// design/rev3/project/views-pending.jsx (PendingActivation).
import { useMsal } from '@azure/msal-react'
import { Icon } from '../components/icons'
import { APP_NAME, APP_SUBTITLE } from '../config'
import { useSupportEmail } from '../lib/useSupportEmail'

export default function PendingActivation() {
  const { accounts } = useMsal()
  const account = accounts[0]?.username
  const supportEmail = useSupportEmail()
  return (
    <div className="vitals" style={{ display: 'flex', flexDirection: 'column', minHeight: '100%', background: 'var(--cream)' }}>
      <header style={{ padding: '26px 40px', display: 'flex', alignItems: 'center', gap: 11 }}>
        <div className="vt-brand-mark"><Icon.spark size={17} /></div>
        <div>
          <div className="vt-brand-name" style={{ color: 'var(--woodland)' }}>{APP_NAME}</div>
          <div className="vt-brand-sub">{APP_SUBTITLE}</div>
        </div>
      </header>

      <main style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px 40px 80px' }}>
        <div style={{ maxWidth: 520, textAlign: 'center' }}>
          <div style={{ width: 64, height: 64, borderRadius: '50%', background: 'var(--surface)', border: '1px solid var(--line)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 26, color: 'var(--viridian)',
            boxShadow: 'var(--shadow-sm)' }}>
            <Icon.clock size={28} />
          </div>
          <h1 style={{ fontSize: 31, fontWeight: 600, letterSpacing: '-0.6px', color: 'var(--woodland)', lineHeight: 1.2 }}>
            Dein Zugang wartet auf Freischaltung
          </h1>
          <p style={{ fontSize: 16, color: 'var(--ink-70)', marginTop: 16, lineHeight: 1.6 }}>
            Wir haben deine Anmeldung erhalten und die Administration benachrichtigt. Sobald dein Zugang freigeschaltet ist, bekommst du eine E-Mail. Du musst nichts weiter tun.
          </p>

          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, marginTop: 26, padding: '10px 16px',
            background: 'var(--surface)', border: '1px solid var(--line)', borderRadius: 24, boxShadow: 'var(--shadow-sm)' }}>
            <span className="vt-status warn" style={{ fontSize: 13.5 }}><span className="vt-dot"></span>Freischaltung ausstehend</span>
          </div>

          {account && (
            <div style={{ marginTop: 38, paddingTop: 26, borderTop: '1px solid var(--line-strong)' }}>
              <div className="vt-eyebrow" style={{ fontSize: 11.5 }}>Angemeldet als</div>
              <div className="vt-mono" style={{ fontSize: 13.5, color: 'var(--ink)', marginTop: 3, fontWeight: 500 }}>{account}</div>
            </div>
          )}

          <p style={{ fontSize: 13.5, color: 'var(--ink-50)', marginTop: 34 }}>
            Dauert es zu lange? <a href={`mailto:${supportEmail}`} style={{ color: 'var(--portugal)', fontWeight: 500, textDecoration: 'none' }}>Operations-Team kontaktieren</a>
          </p>
        </div>
      </main>
    </div>
  )
}
